import { useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";

/**
 * Hook to open the New App dialog from anywhere.
 * Usage: const { open } = useNewAppDialog();
 */
export function useNewAppDialog() {
	const navigate = useNavigate();

	return {
		open: useCallback(() => {
			navigate({ to: "/new-app" });
		}, [navigate]),
	};
}
